import React from "react";
import "./offerBanner.css";

// Import your uploaded images
import offer1 from "../assets/OB1.jpg";
import offer2 from "../assets/OB2.jpg";
import offer3 from "../assets/BI3.jpg"; // <-- Added 3rd image import

function OffersBanner() {
  return (
    <section className="compact-banner-section">
      <div className="compact-banner-container">
        
        {/* Left Side: Short Header */}
        <div className="banner-info">
          <p className="sub-tag">— SPECIAL OFFERS</p>
          <h2 className="banner-title">Exclusive Deals & Rewards</h2>
          <p className="banner-desc">
            Enter our monthly £25 voucher draw or claim 10% off with corporate staff discount.
          </p>
          <a href="#enquire" className="banner-btn">CLAIM AN OFFER ↗</a>
        </div>

        {/* Right Side: Dual Compact Image Cards */}
        <div className="banner-images-grid">
          <div className="mini-card">
            <img src={offer1} alt="Client of the Month Offer" />
          </div>
          <div className="mini-card">
            <img src={offer2} alt="Corporate Staff Discount Offer" />
          </div>
          <div className="mini-card">
            <img src={offer3} alt="Special Promotion Offer" /> {/* <-- Added 3rd card */}
          </div>
        </div>

      </div>
    </section>
  );
}

export default OffersBanner;